import { useNavigate } from "react-router";
import { getActionUrl } from "../../../app/draftHelper";
import {
	CreateEssayResponse,
	useCreateEssayMutation,
	useReviseDraftMutation,
} from "../drafting/draftingApiSlice";
import { WritingAction } from "../writingApiSlice";

export function DraftActionButton(props: {
	action?: WritingAction;
	actionId?: number;
	label?: string;
	disabled?: boolean;
	id?: string;
	className?: string;
}) {
	const [createEssay] = useCreateEssayMutation();
	const [reviseDraft] = useReviseDraftMutation();
	const navigate = useNavigate();

	const handleClick = (e: React.MouseEvent<HTMLElement>): void => {
		e.preventDefault();

		if (props.action === WritingAction.ReviseEssay && props.actionId) {
			reviseDraft(props.actionId)
				.unwrap()
				.then((payload) => {
					navigate(`/writing/write?draftId=${payload.draftId}`);
				})
				.catch((error) => {
					console.log(`reviseDraft failed: ${JSON.stringify(error)}`);
				});
			return;
		}

		if (props.action === WritingAction.StartWriting && props.actionId) {
			createEssay({ promptId: props.actionId })
				.unwrap()
				.then((payload: CreateEssayResponse) => {
					navigate(`/writing/write?draftId=${payload.draftId}`);
				})
				.catch((error) => {
					console.log(`createEssay failed: ${JSON.stringify(error)}`);
				});
			return;
		}

		const actionUrl = getActionUrl(props.action, props.actionId);
		if (!actionUrl) {
			console.log(`handleEssayClick: unknown action "${props.action}"`);
			return;
		}
		navigate(actionUrl);
	};

	const buttonText = ((label, action) => {
		if (label) return label;
		switch (action) {
			case WritingAction.NotStarted:
				return "Begin Assignment";
			case WritingAction.Organize:
				return "Continue Organizing";
			case WritingAction.Write:
				return "Continue Writing";
			case WritingAction.ScoreReport:
				return "View Report";
			case WritingAction.StartOrganizing:
				return "Choose Organizer";
			case WritingAction.StartWriting:
				return "Start Writing";
			case WritingAction.ReviseEssay:
				return "Revise Essay";
			default:
				return null;
		}
	})(props.label, props.action);

	const className = `btn ${props.className ?? "btn-action"}`;

	if (!buttonText) return null;

	return (
		<button id={props.id} className={className} onClick={handleClick} disabled={props.disabled}>
			{buttonText}
		</button>
	);
}
